module.exports = __webpack_public_path__ + "img/loading.7d9ed43f.png";